import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import { getIn } from "formik";
import React from "react";

export default function FormCheckboxWithLabel({
  field: { name, value, onChange, onBlur },
  form: { touched, errors },
  label,
  ...props
}) {
  return (
    <FormControl error={getIn(touched, name) && Boolean(getIn(errors, name))}>
      <FormControlLabel
        sx={{ width: "fit-content" }}
        id={name}
        data-testid={name}
        label={label}
        control={
          <Checkbox
            name={name}
            data-testid={name + "-checkbox"}
            checked={value === "true" || value === true ? true : false}
            onChange={onChange}
            onBlur={onBlur}
            {...props}
          />
        }
        {...props}
      />
      {getIn(touched, name) && Boolean(getIn(errors, name)) && (
        <FormHelperText error>{getIn(errors, name)}</FormHelperText>
      )}
    </FormControl>
  );
}
